export default __webpack_public_path__ + "locales/uk-UA/Files.json?hash=98991541b60b171ddc869230cd3ee792";